export const ACTIVITY_SOURCE = {
  WILDERNESS: 'wilderness',
  JACADA: 'jacada',
};
